/**
 * Check if an object is empty (null, undefined, or no keys).
 */
const isEmptyObject = (obj) => {
  return !obj || Object.keys(obj).length === 0;
};

/**
 * Return a new object with only keys that exist in both A and B,
 * using values from B. If A or B is empty, return {}.
 *
 * @param {object} A
 * @param {object} B 
 * @returns {object}
 */
const extractUpdatedFields = (A, B) => {
  if (isEmptyObject(A) || isEmptyObject(B)) return {};

  const result = {};
  for (const key in B) {
    if (key in A) {
      result[key] = B[key];
    }
  }
  return result;
};

module.exports = {
  extractUpdatedFields,
};
